module.exports = __webpack_public_path__ + "05_long_brown.5046bd75.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/05_long_brown.png
// module id = fLZr
// module chunks = 0